module.exports = __webpack_public_path__ + "static/media/lq-banner-1.f5cd4f81.jpg";